import Link from 'components/ui/link';
import Timezone from '../timezone';
import { SidebarToggle } from './components/SidebarToggle';
import Icon from 'components/ui/icon';
import LiveLogo from '../liveLogo';
import { ChangeLang } from 'components/changeLang';
import HelpDeskToggle from '../helpdeskToggle';
import { ThemeSwitcher } from '../themeSwitcher';
import UserNotificationsIndicator from '../userNotifications/indicator/UserNotificationsIndicator';
import { SearchFilterToggle } from './components/SearchFilterToggle';
import { UserProfile } from './components/UserProfile';
import { Messages } from 'constants/rpcTypes';

export const headerRegistry = {
  SidebarToggle,
  Timezone,

  Help: ({ getTranslate, isEnabled }) =>
    isEnabled(Messages.Article_Menu) && (
      <Link url='/help' className='header__item'>
        <div className='help-button'>
          <span className='help-button__text'>
            {getTranslate('mainMenu.help')}
          </span>
          <Icon name='im-Info' size={12} className='help-button__icon' />
        </div>
      </Link>
    ),

  LiveLogo: ({ isDemoStage }) => isDemoStage && <LiveLogo />,

  Logo: ({ logoUrl }: { logoUrl?: string }) =>
    logoUrl && (
      <Link url='/' className='header__logo'>
        <img src={logoUrl} alt='logo' />
      </Link>
    ),

  ChangeLang: () => (
    <div className='header__item header__item_lang header__item_bordered'>
      <ChangeLang />
    </div>
  ),

  HelpDesk: ({ isNotMaf, isHelpdeskAvailable }) =>
    isNotMaf && isHelpdeskAvailable && <HelpDeskToggle />,

  ThemeSwitcher,

  Notifications: UserNotificationsIndicator,

  Search: SearchFilterToggle,

  UserProfile,
};
